import { Heading, Text } from "@/design-system";
import { ArrowDown } from "lucide-react";
import type { LegalAudiencePath } from "../content/types";

type LegalAudiencePathsProps = {
  paths: LegalAudiencePath[];
};

/**
 * "Para quem é este texto?" — a mesma política serve ao lojista, ao cliente da
 * loja que recebeu uma mensagem e a quem só visitou o site. Cada caminho pula
 * direto para a seção que responde a dúvida daquela pessoa.
 */
export const LegalAudiencePaths = ({ paths }: LegalAudiencePathsProps) => (
  <section
    aria-labelledby="para-quem-title"
    className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 sm:px-6 lg:px-8"
  >
    <div className="flex flex-col gap-2">
      <Heading level={2} size={3} id="para-quem-title">
        Para quem é este texto?
      </Heading>
      <Text tone="muted">Escolha o seu caso e vá direto ao que importa.</Text>
    </div>
    <ul className="grid gap-4 md:grid-cols-3">
      {paths.map(({ audience, icon: Icon, label, description, sectionId }) => (
        <li key={audience}>
          <a
            href={`#${sectionId}`}
            className="group border-ds-border bg-ds-surface rounded-ds-lg hover:border-ds-brand-500 focus-visible:ring-ds-focus flex h-full cursor-pointer flex-col gap-3 border p-4 transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none motion-reduce:transition-none sm:p-6"
          >
            <span className="flex items-center justify-between gap-3">
              <span className="bg-ds-ink-900 text-ds-on-solid rounded-ds-md flex size-10 items-center justify-center">
                <Icon aria-hidden="true" className="size-5" />
              </span>
              <ArrowDown
                aria-hidden="true"
                className="text-ds-ink-500 group-hover:text-ds-brand-700 size-5 transition-colors duration-150 motion-reduce:transition-none"
              />
            </span>
            <Text as="span" weight="semibold">
              {label}
            </Text>
            <Text as="span" size="small" tone="muted">
              {description}
            </Text>
          </a>
        </li>
      ))}
    </ul>
  </section>
);
